export const authOrganizationsInitialState = {
	entities: {},
};

export const authOrganizationInitialState = {
	_id: undefined,
	name: '',
	subdomain: '',
	region: '',
	active: '',
	crm_type: '',
};



// WEBPACK FOOTER //
// ./src/redux/authOrganizations/authOrganization.initialState.js